import { createClient, SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || ''
const supabaseKey =
	process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ||
	process.env.REACT_APP_SUPABASE_ANON_KEY ||
	''

let client: SupabaseClient | null = null

export const isSupabaseConfigured = (): boolean => !!supabaseUrl && !!supabaseKey

export const getSupabase = (): SupabaseClient | null => {
	if (!isSupabaseConfigured()) return null
	if (!client) {
		client = createClient(supabaseUrl, supabaseKey)
	}
	return client
}
